import merge from 'lodash/merge.js';

import Item from '@/store/quill/Item.js';

export default merge(
    Item({
        dates: ['created_at', 'updated_at'],
    }),
    {
        state() {
            return {
                id: null,
                activity_id: null,
                activity_template_id: null,
                course_id: null,
                course_template_id: null,
                criterias: [],
                title: null,
                uuid: null,
                gradingSchemeId: null,
            };
        },

        getters: {},

        actions: {},

        mutations: {
            EDIT: (state, { field, value }) => (state[field] = value),
        },
    }
);
